import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import {SurveyBaseComponent} from "../survey-base/survey-base.component";
import {Constants} from "../../utils/constants";
import { SurveyResponseWrapper } from "src/model/SurveyResponseWrapper";
import { ArticleRatingAnalyticsEvent } from "src/model/analytics/ArticleRatingAnalyticsEvent";

declare var postSurveyResponse;
declare var isJavascriptInjectedIntoWebView;
@Component({
  selector: "app-article-display",
  templateUrl: "./article-display.component.html",
  styleUrls: ["./article-display.component.scss"],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false
})
export class ArticleDisplayComponent extends SurveyBaseComponent implements OnInit, OnDestroy {
    type: any = "";
    locale: any = "";
    articles: any = [];
    prevArticleString = "";
    prevArticles: any = [];
    articleContents : string = "";
    cancelText: string;
    showHeaderFooter = true;
    deviceSerial: string;
    patientId: string;
    origin: string;
    sourceId: string;
    isArticleRatingFeatureEnabled: boolean;
    feedback: string | null = null;
    pageHeaderTextStringId = "care-checkin";
    wasThisHelpfulStringId = "global-was-information-helpful";
    ngOnInit(): void {
        this.articles = this.readFromQueryString("articles").split(",");
        this.prevArticleString = this.readFromQueryString("prevArticles", false);
        this.prevArticles = this.prevArticleString.split(",");
        this.type = this.readFromQueryString("type", false) ?? "smart-coaching";
        this.locale = this.readFromQueryString("locale", false) ?? "en-us";
        this.deviceSerial = this.readFromQueryString("deviceSerial", false);
        this.patientId = this.readFromQueryString("patientId");
        this.origin = this.readFromQueryString("origin", false);
        this.sourceId = this.readFromQueryString("sourceId", false);
        this.isArticleRatingFeatureEnabled = (this.readFromQueryString("isArticleRatingFeatureEnabled", false) ?? "false").toLowerCase() === "true";
        this.showHeaderFooter = (this.readFromQueryString("requestor", false) ?? "").toLowerCase() !== "mobile";
        if (this.articles.length > 1) {
            this.continueText = "continue";
        } else {
            this.continueText = "done";
        }
        if (this.prevArticles.length >= 2) {
            this.cancelText = "back";
        } else if (this.articles.length <= 1) {
            // Don't show both a "Done" and "Close" button if we are on the last article.
            this.cancelText = "";
        } else {
            this.cancelText = "sleep-concierge-v1:selfHelpFollowUpHelpful:positiveButton";
        }
        this.loadArticle(this.articles[0], this.locale, this.type);
    }

    loadArticle(articleId: string, locale: string, type: string): void {
        this.fileManager.getHTMLDataAsync("assets/static/" + type + "/" + locale + "/" + articleId + ".html").then(data => {
            this.articleContents = data
        }).catch(error => {
            console.log(error)
        })
    }

    continueSelected(): void {
       this.createArticleRatingEvent(this.feedback);
        if (this.articles.length > 1) {
            this.prevArticles.unshift(this.articles.shift());
            this.navigate("article?type=" + this.type + "&locale=" + this.locale + "&articles=" + this.articles + "&prevArticles=" + this.prevArticles);
            return;
        }
        this.navigate(Constants.ExitToDashboardAction);
    }

    cancelSelected(): void {
        if (this.prevArticles.length > 1) {
            this.articles.unshift(this.prevArticles.shift());
            this.navigate("article?type=" + this.type + "&locale=" + this.locale + "&articles=" + this.articles + "&prevArticles=" + this.prevArticles);
            return;
        }
        this.navigate(Constants.ExitToDashboardAction);
    }

    selectFeedback(feedback: string): void {
        this.feedback = feedback;
    }

    createArticleRatingEvent(feedback: string): void {
        if (feedback == null) { return; }

        const articleAnalytics = {
            type : 'ARTICLE_RATING_EVENT',
            articleId: this.articles[0],
            deviceSerial: this.deviceSerial,
            patientId: this.patientId,
            origin: this.origin,
            sourceId: this.sourceId,
            category: feedback,
        } as ArticleRatingAnalyticsEvent;
        this.postArticleRatingEvent([articleAnalytics])
    }

    postArticleRatingEvent(articleAnalytics: ArticleRatingAnalyticsEvent[]): void {
        if (isJavascriptInjectedIntoWebView()){
            return postSurveyResponse(new SurveyResponseWrapper(null, articleAnalytics));
        } else {
            this.webInterface.saveAnswers(
                new SurveyResponseWrapper(null, articleAnalytics),
                this.patientId,
                null,
                null)
                .toPromise().catch(err => this.handleException(err));

        }
    }
}
